import AddQuestionnaireMobileContainer from "./AddQuestionnaireMobileContainer";

export default AddQuestionnaireMobileContainer;
